import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "./useAuth";

export const BUSINESS_NAME_QUERY_KEY = ["business-name"];

export function useBusinessName() {
  const { businessId } = useAuth();

  const { data: businessName, refetch } = useQuery({
    queryKey: [...BUSINESS_NAME_QUERY_KEY, businessId],
    queryFn: async (): Promise<string | null> => {
      if (!businessId) return null;
      const { data, error } = await supabase
        .from("businesses")
        .select("name")
        .eq("id", businessId)
        .maybeSingle();
      if (error) throw error;
      return (data as { name: string | null } | null)?.name ?? null;
    },
    staleTime: 1000 * 60 * 5,
    enabled: !!businessId,
  });

  return { businessName: businessName ?? null, refetch };
}
